// Lazily code-splits @emoji-mart so the ~1MB emoji dataset only loads the first
// time a picker is opened. Both the compose box and the message-reaction picker
// share this — they differ only in their onEmojiSelect handler and anchor.
export async function createEmojiPicker({ onEmojiSelect }) {
  const [{ default: data }, { Picker }] = await Promise.all([
    import('@emoji-mart/data'),
    import('emoji-mart')
  ]);

  return new Picker({
    data,
    onEmojiSelect,
    theme: 'light',
    skinTonePosition: 'search',
    previewPosition: 'none',
    perLine: 8,
    locale: window.i18n?.language || 'en'
  });
}
